import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

createReduxPromiseActionType(actionTypes, "ANALYTICS_FETCH");
createReduxPromiseActionType(actionTypes, "ANALYTICS_CLEAR");

export default actionTypes;
